import { TApiResponse } from '@/common/types/response';

import { TAnalyticsNotesYearlyState } from './types';

export function setForeignTradeTemplateData(
  state: TAnalyticsNotesYearlyState,
  response: TApiResponse<TAnalyticsNotesYearlyState['foreignTradeTemplateData']>,
) {
  state.foreignTradeTemplateData = response.data;
}

export function setForeignTradeTable(
  state: TAnalyticsNotesYearlyState,
  data: TAnalyticsNotesYearlyState['foreignTradeTable'],
) {
  state.foreignTradeTable = data;
}

export function setExportStructureTable(
  state: TAnalyticsNotesYearlyState,
  data: TAnalyticsNotesYearlyState['exportStructureTable'],
) {
  state.exportStructureTable = data;
}

export function setImportStructureTable(
  state: TAnalyticsNotesYearlyState,
  data: TAnalyticsNotesYearlyState['importStructureTable'],
) {
  state.importStructureTable = data;
}

export function setExportProductsTable(
  state: TAnalyticsNotesYearlyState,
  data: TAnalyticsNotesYearlyState['exportProductsTable'],
) {
  state.exportProductsTable = data;
}

export function setImportProductsTable(
  state: TAnalyticsNotesYearlyState,
  data: TAnalyticsNotesYearlyState['importProductsTable'],
) {
  state.importProductsTable = data;
}
